import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=32a11a4c"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=32a11a4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports